import { AccessToken, FormDataKeyValuePair, OAuthIntegration } from '@glueapp/graph-types';

const authorizeUrl = 'https://github.com/login/oauth/authorize';
const accessTokenUrl = 'https://github.com/login/oauth/access_token';
const scopes = 'repo';

export const GithubIntegration: OAuthIntegration<
    AccessToken,
    { GITHUB_CLIENT_ID: string; GITHUB_CLIENT_SECRET: string },
    { scope: string }
> = {
    integrationType: 'oauth',
    getAccessTokenUrl(secrets): string {
        return accessTokenUrl;
    },
    getAuthorizationUrl(oauthState, redirectUri, secrets): string {
        return `${authorizeUrl}?client_id=${secrets.GITHUB_CLIENT_ID}&scope=${scopes}&state=${oauthState}&redirect_uri=${redirectUri}`;
    },
    getGrantTypeTokenFormData(queryParams, redirectUri, secrets): FormDataKeyValuePair[] {
        return [
            { key: 'client_id', value: secrets.GITHUB_CLIENT_ID },
            { key: 'client_secret', value: secrets.GITHUB_CLIENT_SECRET },
            { key: 'code', value: queryParams.code },
            { key: 'redirect_uri', value: redirectUri },
        ];
    },
    getRefreshTokenFormData(secrets): FormDataKeyValuePair[] {
        throw new Error('Github does not support token refresh');
    },
    renderOptionLabel() {
        return 'Github';
    },
    requiredSecrets: ['GITHUB_CLIENT_ID', 'GITHUB_CLIENT_SECRET'],
    resolveTokenAndMetaDataFromSuccessResponse(responseData) {
        return {
            tokens: { access_token: responseData.access_token },
            metaData: {
                scope: responseData.scope,
            },
        };
    },
    provider: 'github',
    allowedDomains: ['github.com', 'api.github.com'],
};
